import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

const useStyles = makeStyles((theme) => ({
    toggleContainer: {
        width: "100%",
        marginBottom: theme.spacing(2)
    },
}));

const ToggleButtonComponent = ({ yesLabel, noLabel, yesValue, noValue, onSelect, defaultVal, value }) => {
    const [alignment, setAlignment] = React.useState(value);

    useEffect(() => {
        setAlignment(value)
    }, [value])

    const handleAlignment = (event, newAlignment) => {

        setAlignment(newAlignment);

        onSelect(newAlignment)

    };

    const classes = useStyles();

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <div className={classes.toggleContainer}>
                    <ToggleButtonGroup
                        value={alignment}
                        exclusive

                        onChange={handleAlignment}
                        aria-label="text alignment"
                    >
                        <ToggleButton value={yesValue} aria-label="yes">
                            <div>{yesLabel}</div>
                        </ToggleButton>
                        <ToggleButton value={noValue} aria-label="no">
                            <div>{noLabel}</div>
                        </ToggleButton>

                    </ToggleButtonGroup>
                </div>
            </Grid>

        </Grid>
    );
}

export default ToggleButtonComponent